import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/components/layouts/main-layout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/providers/main.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/lms/src/providers/next-auth-sesstion-provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--inter-font\",\"display\":\"swap\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/lms/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["getInitColorSchemeScript"] */ "/vercel/path0/packages/config-mui/src/color-scheme-script.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/minimal-ui/src/components/snackbar/snackbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/minimal-ui/src/global.css");
